package horcrux.common.api.dtos

import horcrux.common.HorcruxRequestSimpleError
import horcrux.common.api.dtos.types.Answer
import horcrux.common.api.dtos.types.ChatModelConfigs
import horcrux.common.api.dtos.types.CollectionID
import horcrux.common.api.dtos.types.ContextDocumentChunkAndMetadata
import horcrux.common.api.dtos.types.DocumentChunkID
import horcrux.common.api.dtos.types.Question
import horcrux.common.api.dtos.types.UserID
import io.ktor.http.HttpStatusCode
import kotlinx.serialization.Serializable

@Serializable
data class PostQuestionRequest(
    val collectionID: CollectionID,
    val question: Question,
    val chatModelConfigs: ChatModelConfigs,
) : HorcruxValidatedRequest

@Serializable
data class PostQuestionResponse(
    val answer: Answer,
    val contextDocumentChunkAndMetadataList: List<ContextDocumentChunkAndMetadata>,
) : HorcruxResponse

open class PostQuestionError(httpStatusCode: HttpStatusCode) : HorcruxRequestSimpleError(httpStatusCode)

data class DocumentNotFoundInDatabase(
    val documentChunkID: DocumentChunkID,
    val collectionID: CollectionID,
    val userID: UserID
) :
    PostQuestionError(
        HttpStatusCode.NotFound
    )
